export const CONFIG = {
    permissions: {
        registerTemplate: {
            C: 'registerTemplate_C',
            R: 'registerTemplate_R',
            U: 'registerTemplate_U',
            D: 'registerTemplate_D',
        },
        invoiceRelease: {
            C: 'invoiceRelease_C',
            R: 'invoiceRelease_R',
            U: 'invoiceRelease_U',
            D: 'invoiceRelease_D',
        },
        invoiceNotification: {
            C: 'invoiceNotification_C',
            R: 'invoiceNotification_R',
            U: 'invoiceNotification_U',
            D: 'invoiceNotification_D',
        },
        createInvoice: {
            C: 'createInvoice_C',
            R: 'createInvoice_R',
        },
        bundleRelease: {
            S: 'bundleRelease_S',
            R: 'bundleRelease_R',
        },
        invoiceCheckout: {
            R: 'invoiceCheckout_R',
            C: 'invoiceCheckout_C',
        },
        invoiceAdjustment: {
            R: 'invoiceAdjustment_R',
            C: 'invoiceAdjustment_C',
        },
        substituteInvoice: {
            R: 'substituteInvoice_R',
            C: 'substituteInvoice_C',
        },
        invoiceCancel: {
            R: 'invoiceCancel_R',
            D: 'invoiceCancel_D',
        },
        reportCancelling: {
            R: 'reportCancelling_R',
            C: 'reportCancelling_C',
            U: 'reportCancelling_U',
        },
        invoiceManagement: {
            R: 'invoiceManagement_R',
            C: 'invoiceManagement_C',
            U: 'invoiceManagement_U',
            D: 'invoiceManagement_D',
            P: 'invoiceManagement_P',
            S: 'invoiceManagement_S',
            upload: 'invoiceManagement_upload',
            bundleRelease: 'invoiceManagement_bundle_release',
            uploadCancel: 'invoiceManagement_upload_cancel',
            substitute: 'invoiceManagement_substitute',
            adjustment: 'invoiceManagement_ajustment',
            analytic: 'invoiceManagement_analytic',
            convert: 'invoiceManagement_convert',
            checkout: 'invoiceManagement_checkout',
            process: 'invoiceManagement_process',
            reportCancel: 'invoiceManagement_report_cancel',
        },
        uploadInvoice: {
            R: 'uploadInvoice_R',
            C: 'uploadInvoice_C',
        },
        adjustedInvoice: {
            R: 'adjustedInvoice_R',
        },
        invoiceReplacement: {
            R: 'invoiceReplacement_R',
        },
        canceledInvoice: {
            R: 'canceledInvoice_R',
        },
        convertedInvoice: {
            R: 'convertedInvoice_R',
        },
        reportSituationOneMonth: {
            R: 'reportSituationOneMonth_R',
        },
        reportSituationThreeMonths: {
            R: 'reportSituationThreeMonths_R',
        },
        reportStatisticOneMonth: {
            R: 'reportStatisticOneMonth_R',
        },
        reportStatisticThreeMonths: {
            R: 'reportStatisticThreeMonths_R',
        },
        reportInvoiceConverted: {
            R: 'reportInvoiceConverted_R',
        },
        reportInvoiceDetail: {
            R: 'reportInvoiceDetail_R',
        },
        reportInvoiceDebt: {
            R: 'reportInvoiceDebt_R',
        },
        reportInvoiceCombine: {
            R: 'reportInvoiceCombine_R',
        },
        clientManagement: {
            C: 'clientManagement_C',
            R: 'clientManagement_R',
            U: 'clientManagement_U',
            D: 'clientManagement_D',
        },
        uploadClient: {
            C: 'uploadClient_C',
            R: 'uploadClient_R',
        },
        productManagement: {
            C: 'productManagement_C',
            R: 'productManagement_R',
            U: 'productManagement_U',
            D: 'productManagement_D',
        },
        uploadProduct: {
            C: 'uploadProduct_C',
            R: 'uploadProduct_R',
        },
        downProduct: {
            C: 'downProduct_C',
            R: 'downProduct_R',
        },
        unitManagement: {
            C: 'unitManagement_C',
            R: 'unitManagement_R',
            U: 'unitManagement_U',
            D: 'unitManagement_D',
        },
        invoiceTypeManagement: {
            C: 'invoiceTypeManagement_C',
            R: 'invoiceTypeManagement_R',
            U: 'invoiceTypeManagement_U',
            D: 'invoiceTypeManagement_D',
        },
        invoiceSampleManagement: {
            C: 'invoiceSampleManagement_C',
            R: 'invoiceSampleManagement_R',
            U: 'invoiceSampleManagement_U',
            D: 'invoiceSampleManagement_D',
        },
        downloadSoft: {
            R: 'downloadSoft_R',
        },
        emailActiveManagement: {
            R: 'emailActiveManagement_R',
            U: 'emailActiveManagement_U',
        },
        emailServerManagement: {
            R: 'emailServerManagement_R',
            U: 'emailServerManagement_U',
        },
        divisionInformation: {
            C: 'divisionInformation_C',
            R: 'divisionInformation_R',
            U: 'divisionInformation_U',
            D: 'divisionInformation_D',
        },
        systemSetting:{
            R: 'systemSetting_R',
            U: 'systemSetting_U',
        },
        accountManagement: {
            C: 'accountManagement_C',
            R: 'accountManagement_R',
            U: 'accountManagement_U',
            D: 'accountManagement_D',
        },
        roleManagement: {
            C: 'roleManagement_C',
            R: 'roleManagement_R',
            U: 'roleManagement_U',
            D: 'roleManagement_D',
        },
        agenciesManagement: {
            C: 'agenciesManagement_C',
            R: 'agenciesManagement_R',
            U: 'agenciesManagement_U',
            D: 'agenciesManagement_D',
        },
        customerManagement: {
            C: 'customerManagement_C',
            R: 'customerManagement_R',
            U: 'customerManagement_U',
            D: 'customerManagement_D',
        },
        companyManagement: {
            C: 'companyManagement_C',
            R: 'companyManagement_R',
            U: 'companyManagement_U',
            D: 'companyManagement_D',
        },
        divInfomations: {
            R: 'divInfomations_R',
            U: 'divInfomations_U',
        },
        digitalSignature: {
            R: 'digitalSignature_R',
            U: 'digitalSignature_U',
        },
        userPermisions: {
            C: 'userPermisions_C',
            R: 'userPermisions_R',
            U: 'userPermisions_U'
        },
        decisionRelease: {
            C: 'decisionRelease_C',
            U: 'decisionRelease_U',
            D: 'decisionRelease_D',
            templateRegister: 'decisionRelease_template_register',
        },
        announcementInvoiceRelease: {
            C: 'announcementInvoiceRelease_C',
            U: 'announcementInvoiceRelease_U',
            D: 'announcementInvoiceRelease_D',
        },
        announcementManagement: {
            R: 'announcementManagement_R',
            C: 'announcementManagement_C',
            U: 'announcementManagement_U',
            D: 'announcementManagement_D',
            P: 'announcementManagement_P',
        },
        announcementCreated: {
            R: 'announcementCreated_R',
            C: 'announcementCreated_C',
            U: 'announcementCreated_U',
            P: 'announcementCreated_P',
        },
        menuManagement: {
            C: 'menuManagement_C',
            R: 'menuManagement_R',
            U: 'menuManagement_U',
            D: 'menuManagement_D',
        },
        exchangeRate: {
            list: 'exchange_rate_list'
        },
        noticeMail: {
            list: 'noticeMail'
        },
        employeesManagement: {
            C: 'employeesManagement_C',
            R: 'employeesManagement_R',
            U: 'employeesManagement_U',
            D: 'employeesManagement_D',
        },
        contractsManagement: {
            C: 'contractManagement_C',
            R: 'contractManagement_R',
            U: 'contractManagement_U',
            D: 'contractManagement_D',
            P: 'contractManagement_P',
        },
        invoiceCreated: {
            R: 'invoiceCreated_R',
            P: 'invoiceCreated_P',
        },
        invoiceApproved: {
            R: 'invoiceApproved_R',
            S: 'invoiceApproved_S',
        },
        reportManagement: {
            R: 'reportManagement_R'
        }
    },
    minDate: {
        year: 1950,
        month: 1,
        day: 1,
    },
    maxDate: {
        year: 2050,
        month: 1,
        day: 1,
    },
    datetimeFormat: 'DD/MM/YYYY HH:mm',
    dateFormat: 'DD/MM/YYYY',
    serverDateFormat: 'DD/MM/YYYY',
    monthFormat: 'MM/YYYY',
    customerTypes: [
        {
            id: 0,
            key: 'Khách hàng không phải là đơn vị kế toán'
        },
        {
            id: 1,
            key: 'Khách hàng là đơn vị kế toán'
        }
    ],
    typeSendInvoices: [
        {
            id: 1,
            key: 'Gửi hóa đơn qua Email'
        },
        {
            id: 2,
            key: 'Gửi hóa đơn qua SMS'
        }
    ],
    roles: [
        {
            id: 1,
            key: 'accountManagement.roleAdmin',
        },
        {
            id: 2,
            key: 'accountManagement.rolePrinter',
        },
        {
            id: 3,
            key: 'accountManagement.roleAccounting',
        }
    ],
    invoiceStatuses: [
        {
            id: 1,
            key: 'invoiceRelease.invoiceStatuses.new'
        },
        {
            id: 2,
            key: 'invoiceRelease.invoiceStatuses.approveByTaxOffice'
        }
    ],
    announcementStatuses: [
        {
            id: 1,
            key: 'invoiceRelease.invoiceStepStatuses.new'
        },
        {
            id: 3,
            key: 'invoiceRelease.invoiceStepStatuses.approved'
        },
        {
            id: 99,
            key: 'completed'
        }
    ],
    invoiceStepStatuses: [
        {
            id: 1,
            key: 'invoiceRelease.invoiceStepStatuses.new'
        },
        {
            id: 2,
            key: 'invoiceRelease.invoiceStepStatuses.approved'
        },
        {
            id: 3,
            key: 'invoiceRelease.invoiceStepStatuses.releasing'
        },
        {
            id: 4,
            key: 'invoiceRelease.invoiceStepStatuses.released'
        },
        {
            id: 5,
            key: 'invoiceRelease.invoiceStepStatuses.cancel'
        }
    ],
    invoicePaymentStatuses: [
        {
            id: true,
            key: 'invoicePaymentStatus.paid'
        },
        {
            id: false,
            key: 'invoicePaymentStatus.notPaid'
        }
    ],
    invoiceSamples: [
        {
            id: 1,
            key: 'invoiceAdjustment.invoiceReplacing'
        },
        {
            id: 2,
            key: 'invoiceSample.Adjustment'
        },
        // {
        //     id: 3,
        //     key: 'invoiceSample.updateDown'
        // },
        // {
        //     id: 4,
        //     key: 'invoiceSample.updateInfo'
        // },
    ],
    announcementTypes: [
        {
            id: 1,
            key: 'Biên bản điều chỉnh'
        },
        {
            id: 2,
            key: 'Biên bản thay thế'
        },
        {
            id: 3,
            key: 'Biên bản hủy'
        },
    ],
    announTypes: [
        {
            id: 1,
            key: 'button.adjust'
        },
        {
            id: 2,
            key: 'announ.adjustment'
        },
        {
            id: 3,
            key: 'button.cancel'
        },
    ],
    vatTaxss: [
        {
            id: 1,
            key: 'T00'
        },
        {
            id: 2,
            key: 'T05'
        },
        {
            id: 3,
            key: 'T10'
        },
        {
            id: 4,
            key: 'TS0'
        },
    ],
    invoiceAdjustmentTypes: [
        {
            id: 2,
            key: 'invoiceSample.updateUpAndDown'
        },
        {
            id: 3,
            key: 'invoiceSample.updateInfo'
        },
    ],
    listReleaseInvoiceStatuses: [
        {
            id: 0,
            key: 'listReleaseInvoice.statuses.notYet'
        },
        {
            id: 1,
            key: 'listReleaseInvoice.statuses.releaseError'
        },
        {
            id: 2,
            key: 'listReleaseInvoice.statuses.releaseSuccess'
        }
    ],
    disableDeleteByInvoiceReleaseStatusIds: [2],
    disableDeleteByInvoiceNotificationStatusIds: [2],
    defaultTableInvoiceItems: 10,
    listSelectTaxs: new Array(100),
    paymentStatuses: [
        {
            id: false,
            key: 'invoicePaymentStatus.notPaid'
        }, {
            id: true,
            key: 'invoicePaymentStatus.paid'
        }
    ],
    importColumnName: {
        customer: {
            MaKH: 'Mã khách hàng',
            TenKH: 'Tên khách hàng',
            MaSoThue: 'Mã số thuế',
            Diachi: 'Địa chỉ',
            SoDienThoai: 'Số điện thoại',
            Fax: 'Fax',
            Email: 'Email',
            Nguoidaidien: 'Người đại diện',
            Nganhang: 'Ngân hàng',
            Sotaikhoan: 'Số tài khoản',
            ChuTaikhoan: 'Chủ tài khoản',
            KhacHangKetoan: 'Là khách hàng kế toán',
            MoTa: 'Mô tả',
            Hinhthucnhanhoadon: 'Hình thức thanh toán',
            KhachHangToChuc: 'Khách hàng tổ chức',
        },
        product: {
            ProductCode: 'ProductCode',
            ProductName: 'ProductName',
            Price: 'Price',
            UnitId: 'UnitID',
            Unit: 'Unit',
            Describe: 'Describe',
            TaxID: 'TaxID',
        },
        invoice: {
            'IDChungTu/MaBill': 'Id Chứng từ/Mã Bill',
            TenHangHoaDichVu: 'Tên hàng hóa dịch vụ',
            DonViTinh: 'Đơn vị tính',
            SoLuong: 'Số lượng',
            DonGia: 'Đơn giá',
            ThanhTien: 'Thành tiền',
            ThueSuat: 'Thuế suất',
            NgayThangNamHD: 'Ngày HD',
            HoTenNguoiMua: 'Họ tên người mua',
            TenDonVi: 'Tên đơn vị',
            MaSoThue: 'Mã số thuế',
            DiaChi: 'Địa chỉ',
            SoTaiKhoan: 'Số tài khoản',
            HinhThucTT: 'Hình thức Thanh toán',
            TrangThaiTT: 'Trạng thái Thanh toán',
            Email: 'Email',
            DienThoai: 'Điện thoại',
            GhiChu: 'Ghi chú',
            ThueGTGT: 'Thuế GTGT'
        }
    },
    manualHandleErrorCode: [
        5050,
        5051,
        5052,
        5053,
        5054,
        5055,
        5056,
        5057,
    ],
    schemaSign: 'unitsign:token,releaseId',
    agencyTypes: [
        {
            id: 1,
            name: 'Đăng cấp việt'
        },
        {
            id: 2,
            name: 'Đại lý cấp I'
        },
        {
            id: 3,
            name: 'Đại lý cấp II'
        }
    ],
    activationEmailStatuses: [
        {
            id: 0,
            key: 'activationMailsManagement.activationEmailStatuses.unsent'
        },
        {
            id: 1,
            key: 'activationMailsManagement.activationEmailStatuses.sent'
        },
        {
            id: 2,
            key: 'activationMailsManagement.activationEmailStatuses.sendError'
        }
    ],
    contractPayments: [
        {
            id: 1,
            key: 'contractsManagement.contractPayments.byContract'
        },
        {
            id: 2,
            key: 'contractsManagement.contractPayments.byBlockContract'
        },
    ],
    contractStatuses: [
        {
            id: 1,
            key: 'contractsManagement.contractStatuses.active'
        },
        {
            id: 2,
            key: 'contractsManagement.contractStatuses.notActive'
        },
    ],
    contractTypes: [
        {
            id: 1,
            key: 'contractsManagement.contractTypes.customer'
        },
        {
            id: 2,
            key: 'contractsManagement.contractTypes.agency'
        },
    ],
    UserLevel: {
        SYSTEMADMIN: "SYSTEM_ADMIN",
        SALE: "SALE",
        SALE_EMPLOYER: "SALE_EMPLOYER",
        CUSTOMER: "CUSTOMER",
        USER: "USER",
        CLIENT: "CLIENT"
    },
    websiteBuy: 'newinvoice.vn',
    signDescription: 'Phát hành hóa đơn điện tử',
    releaseDescription: 'Phát hành lô hóa đơn ngày ',
    invoiceNotificationSplit: 'Đăng ký sử dụng dấu phân cách là dấu phẩy(,) sau chữ số hàng nghìn, triệu, tỷ, nghìn tỷ, triệu tỷ, tỷ tỷ và sử dụng dấu chấm(.) sau chữ số hàng đơn vị để ghi chữ số sau chữ số hàng đơn vị',
    apiCompanyUrl: 'http://apicompany.new-invoice.com/companies',
    apiCompanyToken: 'NewInvoice',
    
    templateName: {
        ShinhanGroup: 'TemplateGroup_Shinhan.html',
        HuaNanDetail: 'TemplateDetail_HuaNan.html',
        MegaDetail: "TemplateDetail_Mega.html",
        SinoGroup: "TemplateDetail_Sino.html",
        BIDCGroup: "TemplateGroup_BIDC.html",
    },
    mappingUrl : [
        {id: "/", value : 'Portal', name: '[Tra cứu]'},
        {id: "/invoice-list", value : 'Portal', name: '[Tra cứu]'},
        {id: "/Login", value : 'Portal', name: '[Đăng nhập]'},
        {id: "/change-password", value : 'Portal', name: '[Thay đổi mật khẩu]'},
    ],
    customerIndexs: {
        Shinhan: 1,
        HuaNan: 2,
        Mega: 3,
        Sino: 4,
        BIDC: 5,
    },
}
